module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "places_item"
  }, [_c('a', {
    attrs: {
      "href": _vm.src,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.src,
      "alt": "Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "place_name"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-539cd5df"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/places/ItemPlace.vue
// module id = 368
// module chunks = 0